<template>
    <div id="page_04" class="page">
        <div class="content">
            <div class="content_area">
                <div class="item item_left">
                    <p style="font-weight:bold;font-size:1.2rem;">
                        SINCE 2006
                    </p>
                    <p>
                        패션 피플들의<br/>
                        꾸준한 사랑을 받아온<br/>
                        국내 1세대 오프라인 편집샵<br/>
                        SPECIMEN
                    </p>
                </div>
                <div class="item item_right">
                    <img src="@/assets/img/img_page_04_01.png" />
                </div>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page04'
}
</script>

<style scoped>
    .content{background-image:url("../assets/img/bg_page_04.jpg");padding-top:4.038rem;padding-bottom:5.162rem;}
    .item>p{font-size:0.88rem;line-height:1.2rem;}
    .item>p>span{border-bottom:0.1rem solid #000;}
    .item>img{width:10.096rem;height:auto;}
    .item_right{margin-left:2.472rem;}

    @media (max-width:720px) {
        .item_right{margin:0;margin-top:2rem;}
        .item>p{font-size:0.9rem;text-align: center;}
    }        
</style>

